import { render, staticRenderFns } from "./NoteDetailsAttachment.vue?vue&type=template&id=214c05de&scoped=true&"
import script from "./NoteDetailsAttachment.vue?vue&type=script&lang=js&"
export * from "./NoteDetailsAttachment.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetailsAttachment.vue?vue&type=style&index=0&id=214c05de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c05de",
  null
  
)

export default component.exports